import { useEffect, useState } from "react";
import API from "../../../Network/API";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export const PLAN_HIGHLIGHTS = [
    { icon: "fa-light fa-video", text: "subscription.highlight_unlimited_live_classes" },
    { icon: "fa-light fa-users", text: "subscription.highlight_unlimited_live_sessions" },
    { icon: "fa-light fa-hand-holding-dollar", text: "subscription.highlight_zero_commission" },
    { icon: "fa-light fa-clapperboard-play", text: "subscription.highlight_recorded_courses" },
    { icon: "fa-light fa-address-card", text: "subscription.highlight_featured_listing" },
];

export default function Subscription() {
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const { user } = useSelector((state) => state.authReducer);
    const location = useLocation();
    const prefix = location.pathname.startsWith("/app") ? "/app" : "";

    useEffect(() => {
        setLoading(true)
        API.get(`/v1/oauth/teacher/packages`).then((response) => {
            setData(response.data.data.packages)
            setLoading(false)
        }).catch((error) => {
            setLoading(false)
        });

    }, []);


    return (
        <>
            <div className="sub-hero text-center">
                <span className="sub-hero-badge"><i className="fa-light fa-crown me-2" />{t("subscription.room_rent_monthly_plan")}</span>
                <h2 className="sub-hero-title">{t("subscription.teach_without_limits")}</h2>
                <p className="sub-hero-dec">
                    {t("subscription.hero_description")}
                </p>
            </div>

            <div className="row justify-content-center">
                    {!isLoading && data?.length > 0 && data?.map((pack, j) => (
                        <div className="col-xl-5 col-lg-6 col-md-8" key={j}>
                            <div className="pricing-card">
                                <div className="pricing-card-head">
                                    <h4 className="pricing-card-name">{pack.title}</h4>
                                    <div className="pricing-card-price">
                                        <span className="pricing-amount">${pack.price}</span>
                                        <span className="pricing-period">{t("subscription.per_month")}</span>
                                    </div>
                                    {pack.details ? <p className="pricing-card-note">{pack.details}</p> : null}
                                </div>

                                <ul className="list-unstyled pricing-features">
                                    {PLAN_HIGHLIGHTS.map((f, i) => (
                                        <li key={i}>
                                            <span className="pricing-feature-icon"><i className={f.icon} /></span>
                                            <span>{t(f.text)}</span>
                                        </li>
                                    ))}
                                </ul>

                                {user?.is_subscribed ?
                                    <div className="subscribed-panel">
                                        <i className="fa-solid fa-circle-check me-2" />
                                        {t("subscription.subscribed_message")}
                                    </div>
                                    :
                                    <Link to={`${prefix}/dashboard/subscription/checkout?package=${pack.id}`} className="w-100 btn subscribe-btn mt-2">
                                        <i className="fa-light fa-lock me-2" />{t("subscription.subscribe_cta", { price: pack.price })}
                                    </Link>
                                }
                            </div>
                        </div>
                    ))}

            </div>

            {!user?.is_subscribed &&
                <p className="text-center sub-footnote">
                    {t("subscription.footnote")}
                </p>
            }
        </>
    )
}
